import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchMyInstitution = () => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });

		const res = await instance.get("/my-institution");
		return res.data;
	};
	return useQuery("my_institution", () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchMyInstitution;
